/* Built In Imports */

/* External Imports */
import { Box, Flex, SimpleGrid, useTheme, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionTitle from '@components/Headings/SectionTitle';
import ContentArea from '@Layout/ContentArea';
import CardInfoWithDetailsAndProgress from '../components/Card/CardInfoWithDetailsAndProgress';

/* Services */

/**
 * Renders the Artwork Text 3 Group Column component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} Artwork Text 3 Group Column component
 */
const OtpJourneyOverview = ({ sectionContent }) => {
    return (
        <Box
            background={'#405C47'}
            position={'relative'}
            justifyContent={'center'}
            alignContent={"center"}            
            clipPath={{base: 'polygon(0 0%, 6000% 0, 0% 100%)', lg: 'polygon(0 0%, 1500% 0, 0% 100%)'}}
        >
            <Box display={'flex'} alignItems={'center'} my={{base:'1rem', md: '3rem', lg: '3rem' }} 
            >
                <SectionTitle color={'#fff'} titleObj={{...sectionContent[0], titleDecoration: 'otp-yellow-divider'}} />
            </Box>

            <LazyLoadImageComponent
                display={{base: 'none', md: 'none', lg: 'block'}}
                src={'https://www.datocms-assets.com/46272/1743654272-otp-journey-overview-zigzag-line.png'}
                position={'absolute'} right={{lg:'45%', "2xl": '46%'}} top={'14.5rem'}
            />
            {sectionContent?.[1]?.cards?.map((data, index) => {
                return (
                    <Box>
                        <CardInfoWithDetailsAndProgress
                            section={sectionContent}
                            data={data}
                            sectionContent={sectionContent?.[1]}
                            // region={region}
                            // lang={lang}
                            index={index}
                            key={index}
                        />
                    </Box>
                );
            })}
            <Box display={'flex'} alignItems={'center'} justifyContent={'center'} textAlign={'center'} mt={{base:'2rem', md: '3rem', lg: '4rem' }} 
            mb={{base:'3rem', lg:'9rem'}}
            >
                <SimpleButton
                    style={sectionContent?.[2]}
                    bType={sectionContent?.[2]?.sectionId}
                    color={'#28231E'}
                    w={'206px'}
                    lineHeight={'56px'}
                />
            </Box>
        </Box>
    );
};

export default OtpJourneyOverview;